export default __webpack_public_path__ + "static/media/Sebastian.264ae238.png";